import { withNamespace } from "@/i18n/lazy-route"

/** Refund requests (LLD §9.12, Task 5.4), with the `refunds` namespace. */
export const RefundsScreen = withNamespace("refunds", () => import("./screens/RefundsScreen"), {
  en: () => import("@/i18n/locales/en/refunds.json"),
  fr: () => import("@/i18n/locales/fr/refunds.json"),
})
